<template>
  <span
    v-clipboard:copy="text"
    v-clipboard:success="onCopy"
    v-clipboard:error="onError"
    v-b-tooltip.hover="{ variant: variant, placement: 'left' }"
    :title="title"
    class="hover-cursor-pointer"
    :class="cssClass"
  >
    <b-icon :icon="icon" :variant="variant" />
  </span>
</template>

<script>
import { Notify } from '@robustshell/utils/index'

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    cssClass: {
      type: String,
      required: false,
      default: () => '',
    },
    icon: {
      type: String,
      required: false,
      default: 'back',
    },
  },
  data() {
    return {
      title: 'Copy',
      variant: 'warning',
    }
  },
  methods: {
    onCopy(e) {
      this.title = 'Copied'
      this.variant = 'success'
      setTimeout(() => {
        this.title = 'Copy'
        this.variant = 'warning'
      }, 2000)
    },
    onError(e) {
      Notify.danger('Failed to copy text')
    },
  },
}
</script>

<style lang="scss" scoped>
  .hover-cursor-pointer {
    &:hover,
    &:focus,
    &:active {
      cursor: pointer;
    }
  }
  .copied-message {
    margin-left: 5px;
    color: #28a745;
    font-size: 0.9em;
    opacity: 1;
    transition: opacity 0.5s ease;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
